import React from "react";
import {Box, Button} from "@mui/material";
import type {ButtonProps} from "@mui/material/Button";
import PrintIcon from "@mui/icons-material/Print";
import {useTranslation} from "react-i18next";

type Props = Omit<ButtonProps, "children" | "endIcon" | "startIcon"> & {
    label?: string;
};

const getPrintShortcutLabel = () => {
    if (typeof window === "undefined") return "Ctrl + P";

    const platform = window.navigator.platform || window.navigator.userAgent || "";
    return /Mac|iPhone|iPad|iPod/i.test(platform) ? "⌘P" : "Ctrl+P";
};

const PrintShortcut = () => (
    <Box
        component="kbd"
        sx={{
            bgcolor: "transparent",
            border: 0,
            boxShadow: "none",
            color: "inherit",
            fontFamily: "inherit",
            fontSize: 12,
            fontWeight: 600,
            lineHeight: 1,
            ml: 1,
            opacity: 0.72,
            p: 0,
        }}
    >
        {getPrintShortcutLabel()}
    </Box>
);

const PrintPreviewPrintButton = ({
                                     color = "success",
                                     fullWidth = true,
                                     label,
                                     variant = "contained",
                                     ...buttonProps
                                 }: Props) => {
    const {t} = useTranslation();

    return (
        <Button
            {...buttonProps}
            color={color}
            endIcon={<PrintShortcut/>}
            fullWidth={fullWidth}
            startIcon={<PrintIcon/>}
            variant={variant}
        >
            {label ?? t("Print")}
        </Button>
    );
};

export default PrintPreviewPrintButton;
